import {Wrapper} from "../../components";
import img1 from "../../assets/1.png";
import img2 from "../../assets/2.png";
import img3 from "../../assets/3.png";
import img4 from "../../assets/4.png";

function HowItWork(){
    const steps = [
        {
            image: img1,
            step: "1. Adım",
            title: "Hemen Üye Ol!",
            description: "GMS Kripto Kripto para borsası'na kolayca üye ol!"
        },
        {
            image: img2,
            step: "2. Adım",
            title: "Üyeliğini Doğrula!",
            description: "Kimlik bilgilerinizi girerek KYC adımlarını tamamlayın"
        },
        {
            image: img3,
            step: "3. Adım",
            title: "TL/Kripto Para Yatır!",
            description: "Hesabınıza TL veya kripto para yatırarak işlem yapmaya başlayın"
        },
        {
            image: img4,
            step: "4. Adım",
            title: "Kripto Para Al/Sat",
            description: "Platformumuzda favori kripto paralarınızı anında alıp satın"
        }
    ];
    
    return(
        <div className="bg-dark-backgroundOnDark py-24 mt-20 relative overflow-hidden">
            {/* Dekoratif arka plan elementleri */}
            <div className="absolute top-20 left-10 w-64 h-64 bg-primary/5 rounded-full blur-3xl"></div>
            <div className="absolute bottom-20 right-10 w-80 h-80 bg-primary/10 rounded-full blur-3xl"></div>
            
            <Wrapper>
                <div className="text-center mb-16 relative z-10">
                    <h2 className="text-surface-main font-bold text-4xl md:text-5xl">4 Adımda Kripto Para Al/Sat!</h2>
                    <p className="text-secondaryTwo text-lg md:text-xl font-dmsans mt-4 max-w-3xl mx-auto">
                        Hızlı ve güvenilir bir şekilde Kripto Para almak ve satmak 
                        <span className="text-primary font-medium"> çok kolay!</span> 
                        <br/> Hemen üye olun ve kripto dünyasına adım atın.
                    </p>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 relative z-10">
                    {steps.map((step, index) => (
                        <div 
                            key={index}
                            className="bg-dark-background/50 backdrop-blur-sm rounded-2xl p-6 border border-dark-line/30 hover:border-primary/30 transition-all duration-300 flex flex-col items-center text-center group"
                        >
                            <div className="relative mb-6">
                                <div className="absolute -inset-4 bg-primary/10 rounded-full blur-lg opacity-0 group-hover:opacity-100 transition-opacity"></div>
                                <img src={step.image} alt={step.title} className="relative z-10 w-24 h-24 object-contain" />
                            </div>
                            
                            <span className="uppercase font-dmsans text-primary font-bold text-xs mb-2">
                                {step.step}
                            </span>
                            
                            <h3 className="text-surface-main font-bold text-xl mb-2">
                                {step.title}
                            </h3>
                            
                            <p className="text-secondaryTwo">
                                {step.description}
                            </p>
                            
                            {index < steps.length - 1 && (
                                <div className="hidden lg:block absolute top-1/2 left-full -translate-x-1/2 transform -translate-y-1/2 z-20">
                                    <svg width="40" height="24" viewBox="0 0 40 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M39.0607 13.0607C39.6464 12.4749 39.6464 11.5251 39.0607 10.9393L29.5147 1.3934C28.9289 0.807611 27.9792 0.807611 27.3934 1.3934C26.8076 1.97919 26.8076 2.92893 27.3934 3.51472L35.8787 12L27.3934 20.4853C26.8076 21.0711 26.8076 22.0208 27.3934 22.6066C27.9792 23.1924 28.9289 23.1924 29.5147 22.6066L39.0607 13.0607ZM0 13.5H38V10.5H0V13.5Z" fill="rgba(var(--color-primary), 0.5)"/>
                                    </svg>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                
                <div className="mt-16 text-center">
                    <a 
                        href="https://exchange.gmskripto.com/signin" 
                        className="inline-flex items-center justify-center bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary text-white font-medium py-3 px-8 rounded-full shadow-lg shadow-primary/20 transition-all"
                    >
                        Hemen Başla
                    </a>
                </div>
            </Wrapper>
        </div>
    )
}

export {HowItWork}
